import {ref} from "vue";
import useApi from "@/services/useApi";
import {showToast} from "@/helpers/showToast";
import {SUBSCRIPTIONS_PAYMENT_SYSTEMS} from "./consts";

const CANCEL_APIS_BY_PAYMENT_SYSTEM = {
    // [SUBSCRIPTIONS_PAYMENT_SYSTEMS.PAYPAL]: '/api/subscription/cancel/paypal',
    [SUBSCRIPTIONS_PAYMENT_SYSTEMS.STRIPE]: '/api/subscription/cancel/stripe',
    [SUBSCRIPTIONS_PAYMENT_SYSTEMS.WAYFORPAY]: '/api/subscription/cancel/way-for-pay',
    [SUBSCRIPTIONS_PAYMENT_SYSTEMS.INVOICE]: '/api/subscription/cancel/invoice',
}

export const getSubscriptionsBySystem = async (params, proxy) => {
    const data = ref([])
    const meta = ref({
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0
    })
    const {api, reactiveHeaders} = useApi();
    try {
        const response = await api.get('/api/subscriptions', {params, headers: reactiveHeaders.value})
        data.value = response.data.data.subscriptions
        meta.value = response.data.data.meta
    } catch (error) {
        showToast(proxy.$moshaToast, 'error', error.response?.data?.description)
        throw error;
    }

    return {
        data,
        meta: meta.value,
    }
}

export const getSubsPaymentHistory = async (params, proxy) => {
    const history = ref([]);
    const meta = ref({})
    const {api, reactiveHeaders} = useApi();

    try {
        const response = await api.get('/api/subscription/payments', {params, headers: reactiveHeaders.value})
        history.value = response.data.data.payments
        meta.value = response.data.data.meta
    } catch (error) {
        showToast(proxy.$moshaToast, 'error', error.response?.data?.description)
        throw error;
    }

    const getNumbersCount = (arr) => {
        return arr.length
            ? Object.entries(arr[0].numbers).flatMap(([type, numbers]) =>
                numbers.map(number => ({type, number}))
            ) : []
    }

    return {
        history,
        meta: meta.value,
        getNumbersCount
    }
}

export const cancelSubscriptionByType = async ({subscription_id, type}, proxy) => {
    const {api, reactiveHeaders} = useApi();

    try {
        const res = await api.post(
            CANCEL_APIS_BY_PAYMENT_SYSTEM[type],
            {subscription_id: String(subscription_id)},
            {
                headers: reactiveHeaders.value
            }
        )
        showToast(proxy.$moshaToast, 'success', res.data.description)
    } catch (error) {
        showToast(proxy.$moshaToast, 'error', error.response?.data?.description)
        throw error;
    }
}
